import {getGrpcConfig, StaticHostConfig} from '@aboutyou/config';
import {useStandaloneGrpcRequest} from '@aboutyou/data-fetcher';
import {NavigationService_GetResolvedTargetGroupLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.grpc.lazy';
import {GetResolvedTargetGroupRequest} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {
  getCurrentRouteFromUrl,
  getParams,
  PageTypePathMap,
  PageTypes,
} from '@aboutyou/router';
// eslint-disable-next-line monorepo/no-internal-import
import {getPageTypePathsMap_UNSAFE} from '@aboutyou/router/src/route.paths';
import {convertGenderToTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {getEntityIdentifier} from '../hooks/useEntityIdentifier';

export async function getResolvedTargetGroup({
  originalUrl,
  genderCookie,
  staticHostConfig,
}: {
  originalUrl: string;
  genderCookie?: string;

  staticHostConfig: StaticHostConfig;
}) {
  const {locale, device} = staticHostConfig;

  const pageType = locale
    ? getCurrentRouteFromUrl(locale, originalUrl)
    : undefined;
  // eslint-disable-next-line no-restricted-syntax
  const pageTypePathsMap = getPageTypePathsMap_UNSAFE({locale});

  const identifier = getIdentifier({
    url: originalUrl,
    pageType,
    pageTypePathsMap,
  });

  const sessionTargetGroup = convertGenderToTargetGroup({
    gender: genderCookie,
    defaultToFemale: false,
  });

  const grpcConfig = getGrpcConfig(locale, device);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const getData = useStandaloneGrpcRequest(
    {
      method: NavigationService_GetResolvedTargetGroupLazy,
      params: {
        sessionTargetGroup: sessionTargetGroup ?? null,
        identifier: identifier ?? null,
      },
    },
    {
      hostConfig: {
        hostname: staticHostConfig.tadaridaUrl,
        legacyHostname: staticHostConfig.gripsUrl,
      },
      grpcConfig,
    },
  );
  const data = await getData();

  return {
    appliedTargetGroup: data.appliedTargetGroup,
    recommendedTargetGroup: data.recommendedTargetGroup,
  };
}

const getIdentifier = ({
  url,
  pageType: currentPageType,
  pageTypePathsMap,
}: {
  url: string;
  pageType: PageTypes | undefined;
  pageTypePathsMap: PageTypePathMap;
}): GetResolvedTargetGroupRequest['identifier'] => {
  const urlObject = new URL(url, 'https://..');

  const pathname = urlObject.pathname;
  const queryParams = urlObject.searchParams;
  const paramGender = queryParams.get('gender');
  const pathParams = getParams({
    pathname,
    currentPageType,
    pageTypePathsMap,
  });

  const genderParamIdentifier = paramGender
    ? convertGenderToTargetGroup({
        gender: paramGender,
        defaultToFemale: false,
      })
    : undefined;

  return getEntityIdentifier({
    currentPageType,
    genderParamIdentifier,
    pathParams,
    queryParams,
  });
};
